module.exports = __webpack_public_path__ + "static/media/header-hs.c4317169.png";